import { render } from "./my-account.vue?vue&type=template&id=24f2c162&scoped=true"
import script from "./my-account.vue?vue&type=script&lang=js"
export * from "./my-account.vue?vue&type=script&lang=js"

import "./my-account.vue?vue&type=style&index=0&id=24f2c162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f2c162"]])

export default __exports__